export function countFilters (filters: Record<string, unknown>): number {
  const keys = Object.keys(filters)
  const counted = new Set<string>()
  let count = 0

  for (const key of keys) {
    if (counted.has(key)) continue

    const value = filters[key]
    const isEmptyArray = Array.isArray(value) && value.length === 0
    const isEmptyString = typeof value === 'string' && value.trim() === ''
    if (isEmptyArray || isEmptyString || value == null) continue

    if (key.endsWith('_from') || key.endsWith('_to')) {
      const baseKey = key.replace(/_(from|to)$/, '')
      counted.add(baseKey + '_from')
      counted.add(baseKey + '_to')

      const fromValue = filters[`${baseKey}_from`]
      const toValue = filters[`${baseKey}_to`]
      const hasFrom =
        fromValue !== undefined && fromValue !== null && fromValue !== ''
      const hasTo = toValue !== undefined && toValue !== null && toValue !== ''

      if (hasFrom || hasTo) {
        count += 1
      }
    }
    else {
      count += 1
    }
  }

  return count
}
